module.exports = __webpack_public_path__ + "img/jcnr2.f14f1f36.png";